import React from "react";
import { SoundOutlined, MutedOutlined } from "@ant-design/icons";
import useDashPlayer from "../../../../hooks/useDashPlayer";
import "./DashAudioPlayer.css";
import HoverTooltip from "./HoverTooltip";
import SpeakerIndicator from "./SpeakerIndicator";
import TooltipButton from "../../../Template/Buttons/TooltipButton";

interface DashAudioPlayerProps {
  src: string;
}

const DashAudioPlayer: React.FC<DashAudioPlayerProps> = ({ src }) => {
  const { audioRef, isPlaying, currentTime, duration, volume, playbackRate, togglePlay, seekAudio, changeVolume, changePlaybackRate, skip, mute } = useDashPlayer();
  return (
    <div className="audio-player">
      <audio ref={audioRef} />
      <div className="controls">
        <div className="d-flex gap-2 align-items-center w-100 justify-content-between">
          <div className="d-flex gap-2 align-items-center">
            {isPlaying ? (
              <TooltipButton
                iconName="Pause"
                type="secondary"
                text="Click to Pause [Ctrl Shift Space]"
                onClick={togglePlay}
              />
            ) : (
              <TooltipButton
                iconName="Play"
                type="secondary"
                text="Click to Play [Ctrl Shift Space]"
                onClick={togglePlay}
              />
            )}
            {/* <button
              className="media-btn"
              onClick={togglePlay}>
              {isPlaying ? <FontIcon iconName="Pause" /> : <FontIcon iconName="Play" />}
            </button> */}

            <TooltipButton
              iconName="Rewind"
              type="secondary"
              text="Click to Skip Backwards [Ctrl Shift LeftArrow]"
              onClick={() => skip(-1)}
            />
            <TooltipButton
              iconName="FastForward"
              type="secondary"
              text="Click to Skip Forwards [Ctrl Shift RightArrow]"
              onClick={() => skip(1)}
            />

            <div className="d-flex gap-2 align-items-center">
              <input
                type="range"
                min="0.5"
                max="2"
                step="0.5"
                value={playbackRate}
                onChange={changePlaybackRate}
              />
              <span>{playbackRate}x</span>
            </div>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <div className="d-flex gap-2 align-items-center">
              {mute ? <MutedOutlined /> : <SoundOutlined />}
              {/* <SoundOutlined /> */}
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={volume}
                onChange={changeVolume}
              />
            </div>
          </div>
        </div>
        <div className="d-flex gap-2  justify-content-between w-100">
          <span className="text-nowrap">
            {new Date(currentTime * 1000).toISOString().substr(11, 8)} / {new Date(duration * 1000).toISOString().substr(11, 8)}
          </span>
          <div className="d-flex flex-column gap-2 align-items-center w-100 media-progress mt-2">
            <HoverTooltip
              duration={duration}
              currentTime={currentTime}
              seekAudio={seekAudio}
            />
            <div className="w-100">
              <SpeakerIndicator />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashAudioPlayer;
